import React from 'react'

/**
 * They signed in with a landline. Maps to the backend's `mode: 'landline'`.
 *
 * Its own screen rather than one of the three dead ends in LoginNotFoundStep,
 * because it is a different kind of problem. Those say as little as possible
 * on purpose: they are reachable by anyone typing values, so naming the reason
 * would confirm something about a real account. This one names the reason
 * outright, and safely, because a landline is a fact about the number they
 * typed and says nothing about whether any account exists. Telling them
 * instead that we cannot identify them would send them off checking details
 * that were never the problem.
 *
 * Decided server-side (PhoneNumber::isMobile, Google's libphonenumber) rather
 * than by a rule here, so there is one definition of what counts as a mobile.
 */
interface Props {
  onBack: () => void
}

function LoginLandlineStep({ onBack }: Props): React.JSX.Element {
  return (
    <div className="login-step login-step--neutral">
      <h1 className="login-step-heading">Oops! Please enter a mobile number</h1>

      <p className="login-step-subheading">
        Unfortunately you cannot use a landline to access the customer portal.
        Alternatively, you can use your <strong>email address</strong> or{' '}
        <strong>customer number</strong>.
      </p>

      <button type="button" className="btn btn-primary btn-lg btn-block" onClick={onBack}>
        Back to sign in
      </button>
    </div>
  )
}

export default LoginLandlineStep
